export default __webpack_public_path__ + "24ffc6b2c108c50647e85659723be2f4.woff2";